import { c as _c } from "react/compiler-runtime";
import './commitment-avatar-tooltip.scss';
import { TooltipInfo } from '@sola/ark-core/molecules/tooltip-info/tooltip-info.tsx';
export const CommitmentAvatarTooltip = t0 => {
  const $ = _c(3);
  const {
    translation,
    usePortal: t1
  } = t0;
  const usePortal = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== translation || $[1] !== usePortal) {
    t2 = <TooltipInfo triggerClassName="CommitmentAvatarTooltip" contentClassName="label-md lg:label-lg" align="center" alignOffset={-12} collisionPadding={16} usePortal={usePortal}>{translation}</TooltipInfo>;
    $[0] = translation;
    $[1] = usePortal;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};